import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import moment from 'moment' //导入文件
import VueTouch from 'vue-touch'
import axios from 'axios' /* 引入axios进行地址访问*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$http = axios

import '@/assets/iconfont/iconfont.css'

Vue.use(ElementUI)
Vue.use(VueTouch, { name: 'v-touch' })
VueTouch.config.swipe = {
  threshold: 100 //手指左右滑动距离
}
Vue.prototype.$moment = moment //赋值使用
Vue.config.productionTip = false

Vue.use(Vant)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
